/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取旗舰店公告,最新咨询,新闻聚焦,列表数据
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  type:
    | "APP_BANNER"
    | "APP_POPUP"
    | "APP_RECOMMEND_ADVERT"
    | "APP_NOTICE"
    | "APP_PROJECT_ADVERT"
    | "PAY_SUCCESS"
    | "MALL_BANNER"
    | "PC_POPUP"
    | "PC_BOTTOM_FLOAT_LAYER"
    | "PC_BANNER"
    | "FLAGSHIP_STORE_BANNER"
    | "FLAGSHIP_STORE_FALLS_ADVERT"
    | "FLAGSHIP_STORE_SLIDE_SHOW"
    | "FLAGSHIP_STORE_LATEST_NEWS"
    | "FLAGSHIP_STORE_NEWS_FOCUS"
    | "FLAGSHIP_STORE_AFFICHE"
    | "FLAGSHIP_STORE_PRODUCT"
    | "FLAGSHIP_STORE_MALL_BANNER"
    | "PC_NOTICE"
    | "CLOUD_THEATER_BANNER"
    | "CLOUD_THEATER_TOP"
    | "CLOUD_THEATER_BOTTOM"
    | "CLOUD_THEATER_VIDEO"
    | "APP_OPEN_SCREEN"
    | "LIMIT_COUPON"
    | "APP_SEARCH",

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.ArticleInformationDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/shop/information/${type}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
